import WebsitesDomains from "./websites-domains";

export default WebsitesDomains;
